// extracted by mini-css-extract-plugin
export default {"formButtons":"footer-button_formButtons__Dyden"};